<template>
  <div ref="radioButtons" class="ru:radio-buttons">
    <label v-if="label" class="ru:radio-buttons__label">
      <span class="ru:radio-buttons__label-text">
        {{ label }}
      </span>
      <span class="ru:radio-buttons__label-slot">
        <slot name="label" />
      </span>
    </label>
    <Buttons :layout="layout">
      <RuButton
        v-for="(option, index) in options"
        :id="`${id}__${option.value}`"
        :key="index"
        :size="size"
        :level="option.level ? option.level : 'secondary'"
        :active="option.value === value"
        @click="$emit('input', option.value)"
      >
        {{ option.label }}
      </RuButton>
    </Buttons>
  </div>
</template>

<script>
import { debounce } from 'throttle-debounce';
import Buttons from '@/components/atoms/Buttons';
import RuButton from '@/components/atoms/Button';

export default {
  name: 'ComponentsMoleculesLargeRadioButtons',
  components: {
    Buttons,
    RuButton,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    layout: {
      default: 'stretch',
      type: String,
    },
    id: {
      default: null,
      type: String,
    },
    label: {
      default: null,
      type: String,
    },
    value: {
      default: null,
      type: [Boolean, String],
    },
  },
  data() {
    return {
      size: 'large',
    };
  },
  mounted() {
    this.measureAndAdjust();
    window.addEventListener('resize', this.measureAndAdjust);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureAndAdjust);
  },
  methods: {
    measureAndAdjust: debounce(100, async function () {
      this.size = 'large';
      await this.$nextTick();
      if (
        this.$refs.radioButtons.scrollWidth >
        this.$refs.radioButtons.offsetWidth
      ) {
        this.size = null;
      }
    }),
  },
};
</script>

<style lang="scss">
#{$ru} {
  &radio-buttons {
    margin-bottom: var(--base-margin);
    width: 100%;

    &__label {
      margin-bottom: var(--base-margin-tiny);
      color: --rgba(basalt);
      line-height: var(--base-line-height);
      display: flex;

      &-slot {
        padding-left: var(--base-margin-small);
        margin-left: auto;
        #{$ru}tooltip {
          top: 2px;
        }
      }
    }
  }
}
</style>
